export default __webpack_public_path__ + "double-angle-pointing-to-right.png";